import { DossierObjectGroup } from '@europrocurement/l2d-domain';
import React, { createContext, Dispatch, Reducer, useContext, useReducer } from 'react';

type contexStateSocieteGroup = {
    selectedSocieteGroup?: DossierObjectGroup;
    action: string;
    modalOpen: boolean;
};
type ActionProps = {
    type: string;
    payload?: DossierObjectGroup;
};

const initialSocieteGroupAction: contexStateSocieteGroup = {
    selectedSocieteGroup: undefined,
    action: '',
    modalOpen: false,
};
const SocieteGroupActionContext = createContext(initialSocieteGroupAction);
const SocieteGroupActionDispatchContext = createContext<Dispatch<ActionProps>>(() => {});

const SocieteGroupActionReducer: Reducer<contexStateSocieteGroup, ActionProps> = (
    state: contexStateSocieteGroup,
    action: ActionProps,
) => {
    switch (action.type) {
        case 'create': {
            return {
                ...state,
                action: action.type,
                modalOpen: true,
            };
        }

        case 'edit':
        case 'delete': {
            return {
                ...state,
                selectedSocieteGroup: action.payload,
                action: action.type,
                modalOpen: true,
            };
        }

        case 'close_and_reset': {
            return {
                ...state,
                selectedSocieteGroup: undefined,
                action: '',
                modalOpen: false,
            };
        }

        default: {
            throw Error(`Unknown action: ${action.type}`);
        }
    }
};

export const SocieteGroupProvider: React.FunctionComponent<React.PropsWithChildren> = function ({
    children,
}) {
    const [SocieteGroupAction, dispatch] = useReducer(
        SocieteGroupActionReducer,
        initialSocieteGroupAction,
    );

    return (
        <SocieteGroupActionContext.Provider value={SocieteGroupAction}>
            <SocieteGroupActionDispatchContext.Provider value={dispatch}>
                {children}
            </SocieteGroupActionDispatchContext.Provider>
        </SocieteGroupActionContext.Provider>
    );
};

export function useSocieteGroupAction() {
    return useContext(SocieteGroupActionContext);
}

export function useSocieteGroupActionDispatch() {
    return useContext(SocieteGroupActionDispatchContext);
}
